<template>
    <div class="about-us">
        <div class="about-us-wrap">
            <div class="banner">
                <div class="inner-wrap">
                    <div class="title">
                        <span>飛豬</span><span>&nbsp;</span><span>解決租房的大小事</span>
                    </div>
                    <div class="subtitle">Solve Everything of Renting</div>
                </div>
            </div>
            <div class="service">
                <div class="title-wrap">
                    <div class="line"></div>
                    <div class="title">關於我們</div>
                </div>
                <div class="subtitle">飛豬平台是專門為物管公司、屋主與房客設計的專業租賃平台，我們充分了解租房市場的痛點，提供深度的解決方案，讓飛豬平台幫您一手掌握。</div>
                <div class="service-item">
                    <div class="container">
                        <div class="row">
                            <div class="top">
                                <div class="item orange"><div>媒合找房</div></div>
                                <div class="item darkblue"><div>電子簽約</div></div>
                                <div class="item blue"><div>線上繳租</div></div>
                            </div>
                            <div class="bottom">
                                <div class="item yellow"><div>委託代看</div></div>
                                <div class="item red"><div>評價機制</div></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="product-wrap">
                    <div class="container">
                        <div class="product">
                            <div class="row">
                                <img class="picture" src="@/assets/img/landingPage/aboutUs/find_house.png"/>
                                <div class="info">
                                    <img src="@/assets/img/landingPage/aboutUs/find_house_app.png"/>
                                    <div class="title">飛豬找房</div>
                                    <div class="description">希望提供房客一個有溫度的租房APP，沒有假廣告的騷擾、提供免仲介費的房源，讓您精準的找到適合的房源。我們關心租房過程的不便，也在意租房過後的評價，致力打造更好的租房生態。</div>
                                    <div class="btn-row">
                                        <div class="app-btn">
                                            <a :href="hostUrlTenant" class="tenant-app-download-link-mb">
                                                <button class="empty-btn">App下載</button>
                                            </a>
                                            <button class="empty-btn tenant-app-download-link-pc">App下載</button>
                                            <div class="app">
                                                <div class="top-text">房客APP</div>
                                                <div class="qrcode-wrap">
                                                    <vue-qrious class="qrcode" :value="hostUrlTenant"  :size="size" level="M"/>
                                                    <img class="qrcode-inner-img" src="@/assets/img/landingPage/aboutUs/find_house_app.svg"/>
                                                </div>
                                                <div class="bottom-text blue">飛豬管家</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="product">
                            <div class="row">
                                <div class="info">
                                    <img src="@/assets/img/landingPage/aboutUs/flypig.svg"/>
                                    <div class="title">飛豬管家- 個人房東</div>
                                    <div class="description">我們了解個人房東的痛點，飛豬管家提供網頁版與APP，讓您能更便利的使用飛豬管家，無論是出租速度、收款不易或是帳務混亂，都能諮詢我們取得解決方法。</div>
                                    <div class="btn-row">
                                        <div>
                                            <router-link :to="{ name: 'landlordLogin'}">
                                                <button class="orange-btn">網頁登入</button>
                                            </router-link>
                                        </div>
                                        <div class="app-btn">
                                            <a :href="hostUrlLandlord" class="landlord-app-download-link-mb">
                                                <button class="empty-btn">App下載</button>
                                            </a>
                                            <button class="empty-btn landlord-app-download-link-pc">App下載</button>
                                             <div class="app">
                                                <div class="top-text">個人房東APP</div>
                                                <div class="qrcode-wrap">
                                                    <vue-qrious class="qrcode" :value="hostUrlLandlord"  :size="size" level="M"/>
                                                    <img class="qrcode-inner-img" src="@/assets/img/landingPage/aboutUs/flypig.svg"/>
                                                </div>
                                                <div class="bottom-text orange">飛豬管家</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <img class="picture" src="@/assets/img/landingPage/aboutUs/landlord.png"/>
                            </div>
                        </div>
                        <div class="product">
                            <div class="row">
                                <img class="picture" src="@/assets/img/landingPage/aboutUs/enterprise.png"/>
                                <div class="info">
                                    <img src="@/assets/img/landingPage/aboutUs/flypig.svg"/>
                                    <div class="title">飛豬管家- 企業版</div>
                                    <div class="description">飛豬管家企業版，是一個專門為物業管理公司打造的產品，致力於解決租房效率，提升每個環節的轉化率，可以更精準的掌握細節。我們提供的服務可以有效減少成本與提升效率，讓公司能更專注在核心服務與創造業績。</div>
                                    <div class="btn-row">
                                        <div>
                                            <router-link :to="{ name: 'bizLogin'}">
                                                <button class="orange-btn">網頁登入</button>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import VueQrious from 'vue-qrious'

export default {
    mounted () {
        this.$analytics.logEvent("關於我們", {
            screen_name: "關於我們"
        });
    },
    components: {
        VueQrious
    },
    data () {
        return {
            size: 100,
            hostUrlTenant: window.location.href + '?device=1&type=tenant',
            hostUrlLandlord: window.location.href + '?device=1&type=landlord',
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.about-us {
    margin-bottom: 40px;
    .about-us-wrap {
        .landlord-app-download-link-mb {
            display: none;
        }
        .landlord-app-download-link-pc {
            display: block;
        }
        .tenant-app-download-link-mb {
            display: none;
        }
        .tenant-app-download-link-pc {
            display: block;
        }
        .container {
            width: 911px;
            margin-left: auto;
            margin-right: auto;
            box-sizing: border-box;

            .row {
                display: flex;
            }
        }
        button {
            padding: 6px 27px 7px;
            border-radius: 22px;
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            margin-right: 24px;
            cursor: pointer;

            &.empty-btn {
                border: solid 1px #353535;
                background-color: #fff8f7;
                color: #353535;
            }
            &.orange-btn {
                background-color: #ff9275;
                color: #ffffff;
            }
        }
        .banner {
            position: relative;
            margin-bottom: 50px;
            height: 400px;
            width: 100%;
            background-image: url('../../../assets/img/landingPage/aboutUs/banner.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            .inner-wrap {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: #2f3e55;
                padding: 46px 164px;
                opacity: 0.93;
                border-radius: 48px 0px 48px 0px;

                .title {
                    margin-bottom: 12px;
                    span {
                        font-size: 32px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        letter-spacing: normal;
                        color: #ffffff;
                        white-space: nowrap;
                    }
                    span:nth-child(1) {
                        font-size: 46px;
                    }
                }
                .subtitle {
                    font-size: 24px;
                    color: #ffffff;
                }
            }
        }
        .service {
            background-color: #ffffff;
            margin-bottom: 125px;
            .title-wrap {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 22px;
                .line {
                    width: 6px;
                    height: 24px;
                    border-radius: 3px;
                    background-color: #ff6868;
                    margin-right: 12px;
                }
                .title {
                    font-size: 22px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #ff6868;
                }
            }
            .subtitle {
                width: 723px;
                font-size: 24px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #28292d;
                margin: auto;
                margin-bottom: 70px;
            }
            .service-item {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 125px;
                .top {
                    display: flex;
                    align-items: center;
                    
                    .item {
                        margin-right: 30px;
                    }
                }
                .bottom {
                    display: flex;
                    align-items: center;

                    .item {
                        margin-right: 30px;
                    }
                    .item:last-child {
                        margin-right: 0px;
                    }
                }
                .item {
                    width: 158px;
                    height: 158px;
                    border-radius: 50%;
                    text-align: center;
                    position: relative;
                    div {
                        color: #ffffff;
                        font-size: 24px;
                        font-weight: normal;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: normal;
                        letter-spacing: normal;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        white-space: nowrap;
                    }
                }
                .item:nth-child(1) { 
                    margin-left: 0px;
                }
                .item.orange {
                    background-color: #ff9275;
                }
                .item.darkblue {
                    background-color: #3942b5;
                }
                .item.blue {
                    background-color: #71aae5;
                }
                .item.yellow {
                    background-color: #fcb773;
                }
                .item.red {
                    background-color: #fc7171;

                }
            }
            .product-wrap {
                padding: 160px 0px;
                background-color: #fff8f7;

                .product {
                    margin-bottom: 240px;
                    .info {
                        width: 440px;
                        img {
                            width: 50px;
                            height: 50px;
                        }
                        div {
                            &.title {
                                font-size: 32px;
                                font-weight: 500;
                                font-stretch: normal;
                                font-style: normal;
                                line-height: normal;
                                letter-spacing: normal;
                                color: #353535;
                                margin-top: 20px;
                            }
                            &.description {
                                font-size: 16px;
                                font-weight: normal;
                                font-stretch: normal;
                                font-style: normal;
                                line-height: normal;
                                letter-spacing: normal;
                                color: #353535;
                                margin-top: 8px;
                            }
                            &.btn-row {
                                display: flex;
                                align-items: center;
                            }
                        }

                        .app-btn {
                            position: relative;
                            .app {
                                padding: 24px;
                                border-radius: 4px;
                                box-shadow: 0 2px 10px 0 rgba(67, 67, 67, 0.46);
                                background-color: #ffffff;
                                text-align: center;
                                position: absolute;
                                top: 61px;
                                left: 0;
                                z-index: 2;
                                display: none;
                                
                                .top-text {
                                    font-size: 14px;
                                    font-weight: normal;
                                    font-stretch: normal;
                                    font-style: normal;
                                    line-height: normal;
                                    letter-spacing: normal;
                                    color: #474342;
                                }
                                .qrcode-wrap {
                                    margin: 10px 0px;
                                    position: relative;
                                    .qrcode {
                                        width: 100px;
                                        height: 100px;
                                        padding: 9px;
                                        border-radius: 4px;
                                        border: solid 1px #474342;
                                        background-color: #ffffff;
                                    }
                                    .qrcode-inner-img {
                                        width: 30px;
                                        height: 30px;
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                    }
                                }
                                .bottom-text {
                                    font-size: 14px;
                                    font-weight: bold;
                                    font-stretch: normal;
                                    font-style: normal;
                                    line-height: normal;
                                    letter-spacing: normal;

                                    &.orange {
                                        color: #fb9479;
                                    }
                                    &.blue {
                                        color: #2479fa;
                                    }
                                }
                            }
                        }
                        .app-btn:hover {
                            .app {
                                display: block;
                            }
                        }
                    }

                    &:nth-child(1) {
                        img.picture {
                            width: 357px;
                            height: auto;
                            margin-right: 113px;
                        }
                        .info {
                            .btn-row {
                                margin-top: 81px;
                            }
                        }
                    }
                    &:nth-child(2) {
                        img.picture {
                            width: 366px;
                            height: auto;
                            margin-left: 104px;
                        }
                        .info {
                            .btn-row {
                                margin-top: 64px;
                            }
                        }
                    }
                    &:nth-child(3) {
                        margin-bottom: 0px;
                        img.picture {
                            width: 366px;
                            height: auto;
                            margin-right: 104px;
                        }
                        .info {
                            .btn-row {
                                margin-top: 40px;
                            }
                        }
                    }
                }
            }
            
        }
    }
}
@media screen and (max-width: 1100px){
    .about-us {
        margin-bottom: 40px;
        .about-us-wrap {
            .landlord-app-download-link-mb {
                display: block;
            }
            .landlord-app-download-link-pc {
                display: none;
            }
            .tenant-app-download-link-mb {
                display: block;
            }
            .tenant-app-download-link-pc {
                display: none;
            }

            .container {
                width: 100%;
                padding: 0px 20px;
                margin: unset;

                .row {
                    flex-wrap: wrap;
                }
            }
            .banner {
                height: 198px;
                .inner-wrap { 
                    padding: 16px 51px;

                    .title {
                        margin-bottom: 4px;
                        span {
                            font-size: 18px;
                        }
                        span:nth-child(1) {
                            font-size: 24px;
                        }
                    }
                    .subtitle {
                        font-size: 14px;
                    }
                }
            }
            .service {
                .title-wrap {
                    margin-bottom: 16px;
                    .line {
                        width: 4px;
                        height: 15px;
                        margin-right: 8px;
                    }
                    .title {
                        font-size: 14px;
                    }
                }
                .subtitle {
                    width: unset;
                    padding: 20px;
                    font-size: 16px;
                    margin-bottom: 48px;
                }
                .service-item {
                    display: block;
                    margin-bottom: 70px;
                    .top {
                        width: 100%;
                        margin-bottom: 26px;
                        .item {
                            margin-right: 20px;
                        }
                        .item:last-child {
                            margin-right: 0px;
                        }
                    }
                    .bottom {
                        width: 100%;
                        .item {
                            margin-right: 20px;
                        }
                        .item:last-child {
                            margin-right: 0px;
                        }
                    }
                    .item {
                        width: 158px;
                        height: 158px;
                        div {
                            font-size: 24px;
                        }
                    }
                }
                .product-wrap { 
                    padding: 60px 0px;
                    .product {
                        margin-bottom: 95px;
                        .info {
                            width: 100%;
                            margin-top: 40px;

                            .app-btn:hover {
                                .app {
                                    display: none;
                                }
                            }
                        }
                        div {
                            &.title {
                                font-size: 24px;
                                margin-top: 20px;
                            }
                            &.description {
                                font-size: 16px;
                                margin-top: 10px;
                            }
                            &.btn-row {
                                margin-top: 36px;
                            }
                        }
                        .img.picture {
                            
                        }
                        &:nth-child(1) {
                            img.picture {
                                width: 100%;
                                height: auto;
                                margin-left: 2px;
                                margin-right: 2px;
                                order: 1;
                            }
                            .info {
                                order: 2;
                                .btn-row {
                                    margin-top: 36px;
                                }
                            }
                        }
                        &:nth-child(2) {
                            img.picture {
                                width: 100%;
                                height: auto;
                                margin-left: 2px;
                                margin-right: 2px;
                                order: 1;
                            }
                            .info {
                                order: 2;
                                .btn-row {
                                    margin-top: 36px;
                                }
                            }
                        }
                        &:nth-child(3) {
                            margin-bottom: 0px;
                            img.picture {
                                order: 1;
                                width: 100%;
                                height: auto;
                                margin-left: 2px;
                                margin-right: 2px;
                            }
                            .info {
                                order: 2;
                                .btn-row {
                                    margin-top: 36px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 500px){
    .about-us {
        .about-us-wrap {
            .service {
                .service-item {
                    .item {
                        width: 98px;
                        height: 98px;
                        div {
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/officailPage/aboutUs/aboutUs.vue